import { A06, A06Input, A06Output } from 'api/U005';
import { useEffect, useState } from 'react';

export function useGetAuditionConsentHooks(
  input: A06Input
): [A06Output | undefined, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(true);
  const [consent, setConsent] = useState<A06Output>();
  const [err, setError] = useState<Error | null>(null);

  const fetchConsent = async (input: A06Input, cancellation: AbortSignal) => {
    return await A06(input, cancellation);
  };

  useEffect(() => {
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      setLoading(true);
      setError(null);
      try {
        const consent = await fetchConsent(input, cancellation);
        setConsent(consent);
      } catch (err) {
        console.error(err);
        setConsent(undefined);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      // controller.abort()
    };
  }, []);

  return [consent, loading, err];
}
